import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";

import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { zipFileUploadProject } from "@/services/api/cresivoxServer";

import { REDUCER_NAME, iProjectDTO } from './Types';
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const AddProject = createAsyncThunk<
  iGenericResponse<any | null> | null,
  FormData,
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("AddProject"),
  // @ts-expect-error
  async (formData, { rejectWithValue }) => {
    try {
      const response = await zipFileUploadProject.AddProject(formData);
      if (response) {
        const { httpStatusCode, data, message } = response;
        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_CREATED:
            return { data, message };
          default:
            return rejectWithValue({ httpStatusCode, message });
        }
      } else {
        return rejectWithValue({ message: "No response received" });
      }
    } catch (error) {
      console.error("🚀 ~ AddProject error:", error);
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);

export const GetProject = createAsyncThunk<
  iGenericResponse<any | null> | null,   // Return type
  string,                                // ✅ Vendor argument type
  { rejectValue: iStateMessage }         // ThunkAPI type
>(
  curriedGetThunkName("GetProject"),
  // @ts-expect-error
  async (vendorId, { rejectWithValue }) => {  // ✅ vendor argument comes first
    try {
      const response = await zipFileUploadProject.GetProject(vendorId); // ✅ Pass vendor to service

      if (response) {
        const { httpStatusCode, data, message } = response;
        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              return {
                data: {
                  data: data.data,
                  message,
                },
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default:
            return rejectWithValue({
              httpStatusCode,
              message,
            });
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);


export const UpdateProjectStatus = createAsyncThunk<
  iGenericResponse<any | null> | null,
  { projectId: string; status: string },
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("UpdateProjectStatus"),
  // @ts-expect-error
  async ({ projectId, status }, { rejectWithValue }) => {
    try {
      const response = await zipFileUploadProject.UpdateProjectStatus(projectId, status);

      if (response) {
        const { httpStatusCode, data, message } = response;

        if (httpStatusCode === httpStatusCodes.SUCCESS_OK && data?.data) {
          return { data: { data: data.data, message } };
        }

        return rejectWithValue({ httpStatusCode, message });
      }

      return rejectWithValue({ message: "No response received" });
    } catch (error) {
      console.error("🚀 ~ UpdateProjectStatus error:", error);
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);




export const GetAdminAllProject = createAsyncThunk<
  iGenericResponse<any | null> | null,   // Return type
  void,                                  // ❌ No argument now
  { rejectValue: iStateMessage }         // ThunkAPI type
>(
  curriedGetThunkName("GetAdminAllProject"),
  // @ts-expect-error
  async (_, { rejectWithValue }) => {  // ❌ Removed vendorId, use underscore for unused arg
    try {
      const response = await zipFileUploadProject.GetAdminAllProject(); // ✅ Call without argument
      if (response) {
        const { httpStatusCode, data, message } = response;
        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              return {
                data: {
                  data: data.data,
                  message,
                },
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default:
            return rejectWithValue({
              httpStatusCode,
              message,
            });
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);




export const deleteProject = createAsyncThunk<
  iGenericResponse<any | null> | null,
  { projectId: string },
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("deleteProject"),
  // @ts-expect-error
  async (arg, { rejectWithValue }) => {
    try {

      // ✅ Wrap projectId in an array
      const response = await zipFileUploadProject.deleteProject({
        projectId: [arg.projectId],
      });

      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK:
            if (data && data.data) {
              return {
                data: { data: data.data, message },
              };
            }
            return rejectWithValue({ httpStatusCode, message });
          default:
            return rejectWithValue({ httpStatusCode, message });
        }
      }

      return rejectWithValue({ message: "No response received" });
    } catch (error) {
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);
